export const childSize = {
  small: 'small',
  medium: 'medium',
};

export const childWidthRange = {
  small: { from: 198, to: 341 },
  medium: { from: 342, to: 534 },
};
